import React, { useState } from 'react';
import ReachMe from '../components/reach-me';
import { FaGithub } from 'react-icons/fa';
import { TfiWorld } from 'react-icons/tfi';
import spl from '../assets/portfolio/spl.png';
import tv from '../assets/portfolio/tv.png';
import th from '../assets/portfolio/th.png';
import mshop from '../assets/portfolio/mshop.png';
import w1 from '../assets/portfolio/w1.png';
import lik from '../assets/portfolio/lik.png'
import w3 from '../assets/portfolio/w3.png';
import apartech from '../assets/portfolio/apartech.png'
import { Reveal,Zoom,Slide } from 'react-reveal';


const allProjects = [
  {
        title: 'Taste Heavens Burgers Site',
        description: 'A delightful burger-themed website crafted with ReactJS, perfect for frontend web development practice.',
        tech:'Tech stack: ReactJS,HTML and CSS',
        class: 'Frontend Web dev',
        image: th,
        liveLink: 'https://tasteheavens.vercel.app/',
        githubLink: 'https://github.com/A-Leslie/Food_Order_React_Website.git'
      },
      {
        title: 'Apartech',
        description: 'Experience efficient property management with our Real Estate Management App.',
        tech:'Tech stack: Typescript,HTML,CSS,Material-ui.',
        class: 'Fullstack app',
        image: apartech,
        liveLink: 'https://apartech.vercel.app/',
        githubLink: 'https://github.com/A-Leslie/apartech-frontend.git'
      },
      {
        title: 'TripVista',
        description: 'Embark virtual adventures with TripVista,a React.js-powered tour management site.',
        tech:' Tech stack : React.js, Node.js,MongoDB, and Tailwind CSS',
        class: 'Fullstack app',
        image: tv,
        liveLink: 'https://tripvistatour.vercel.app/',
        githubLink: 'https://github.com/A-Leslie/tripvista.git'
      },
      // {
      //   title: 'Mshop',
      //   description: 'A frontend masterpiece with TypeScript, HTML, and CSS. Elevate your shopping with a captivating watch enthusiast\'s journey. ',
      //   tech:'Tech stack: Typescript,HTML and CSS',
      //   class: 'Frontend Web dev',
      //   image: mshop,
      //   liveLink: 'https://m-shopcart.vercel.app/',
      //   githubLink: 'https://github.com/A-Leslie/react-typescript-shopping-cart.git'
      // },
      // {
      //   title: 'Splendid Poetry',
      //   description: 'Immerse yourself in the world of poets and poetry enthusiasts with Splendid Poetry, a captivating UI/UX design masterpiece crafted using Figma',
      //   tech:'Used tool(s):Figma',
      //   class: 'UI/UX design',
      //   image: spl,
      //   figmaLink: 'https://www.figma.com/file/D7VOFnsLs1MsJCrLSxtLNS/Splendid-Poetry?type=design&node-id=0-1&mode=design&t=0iHZMgDXLVpb9Vqv-0'
      // },
      {
        title: 'Wecare Medical App',
        description: 'Elevate healthcare experiences with the Wecare Medical App stunning UI/UX design, meticulously created in Figma.',
        tech:'Used tool(s): Figma',
        class: 'UI/UX design',
        images: [w1, w3],
        figmaLink: 'https://www.figma.com/file/gUf2wlDpKvnIKcMgtYACEk/Wecare-medical-phone-app?type=design&node-id=0-1&mode=design&t=jYMBTCET95aHed68-0'
      },
      // {
      //   title: 'LikeUs Charity website',
      //   description: 'Impact lives with LikeUs Charity\'s heartfelt UI/UX design, born from Figma. Unveil a design devoted to children\'s well-being.',
      //   tech:'Used tool(s): Figma',
      //   class: 'UI/UX design',
      //   image: lik,
      //   figmaLink: 'https://www.figma.com/file/uprxwo82XSMfaUVcmvWfmE/Charity-Organization-Like-Us?type=design&node-id=0-1&mode=design&t=NsgDCIPAPKIG9Hf5-0'
      // },
    
];

function Projects() {
  const [selectedClass, setSelectedClass] = useState('All');
  const [hoveredProject, setHoveredProject] = useState(null);
  
  const projects = selectedClass === 'All' ? allProjects : allProjects.filter(project => project.class === selectedClass);

  return (
    <section className='bg-black sm:w-12/12'>
      <div className="title flex justify-center p-3">
        <div className='text mt-8'> 
          <h1 className='text-orange-default font-bold text-3xl'>ALL PROJECTS</h1>
        </div>
      </div>
      <Reveal>
      <div className="classes ">
       <ul className='w-12/12 pl-10 flex text-gray-300 font-sm lg:font-medium gap-8 lg:justify-center pt-8 md:justify-center'>
         <li
            className={`hover:text-orange-default ${selectedClass === 'All' ? 'text-orange-default' : ''}`}
           onClick={() => setSelectedClass('All')}
         >
            All
           </li>
           <li
             className={`hover:text-orange-default ${selectedClass === 'UI/UX design' ? 'text-orange-default' : ''}`}
             onClick={() => setSelectedClass('UI/UX design')}
           >
             UI/UX design
           </li>
           <li
             className={`hover:text-orange-default ${selectedClass === 'Frontend Web dev' ? 'text-orange-default' : ''}`}
             onClick={() => setSelectedClass('Frontend Web dev')}
           >
            Frontend Web dev
           </li>
           <li
             className={`hover:text-orange-default ${selectedClass === 'Fullstack app' ? 'text-orange-default' : ''}`}
             onClick={() => setSelectedClass('Fullstack app')}
           >
             Fullstack app
           </li>
         </ul>
      </div>
      </Reveal>
      <Zoom>
      <div className="cards grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-20 pt-20 lg:pl-20 md:pl-16">
        {projects.map((project, index) => (
          <div
            key={index}
            className={`card bg-grey-default w-full md:w-9/12  h-25 ml-0 md:ml-4 hover:bg-gray-900 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-105 relative items-center justify-center`}
            onMouseEnter={() => setHoveredProject(index)}
            onMouseLeave={() => setHoveredProject(null)}
          >
            <div className="img w-10/12 ml-10 mt-10">
              {project.images ? (
                <div className="flex justify-center">
                  {project.images.map((image, i) => (
                    <img key={i} src={image} alt="" className='h-40 mr-2' />
                  ))}
                </div>
              ) : (
                <img src={project.image} alt="" />
              )}
            </div>
            <div className={`project-text text-start p-2 ml-8 ${hoveredProject === index ? 'opacity-0' : 'opacity-100'}`}>
              <h2 className='text-orange-default font-bold text-xl pb-4'>{project.title}</h2>

            </div>
            <div className={`project-info absolute top-0 left-0 w-full h-full p-6 bg-gray-900 text-white transition duration-300 ease-in-out transform ${hoveredProject === index ? 'translate-x-0 opacity-95' : 'translate-y-32 opacity-0'}`}>
              <h2 className='text-gray-300 font-bold text-xl'>{project.title}</h2>
              <p className='text-gray-400 font-medium'>{project.description}</p>
              <p className='text-gray font-medium'>{project.tech}</p>
              {project.liveLink && project.githubLink && (
                 <div className="pro_info flex space-x-32">
                   <p className='text-orange-400 font-bold text-md flex'>
                     <TfiWorld className='mt-1 mr-1'/>                     <a href={project.liveLink} target="_blank" rel="noopener noreferrer">live</a>
                   </p>
                   <p className='text-orange-400 font-bold text-md flex'>
                     <FaGithub className='mt-1 mr-1'/>
                     <a href={project.githubLink} target="_blank" rel="noopener noreferrer">github</a>
                   </p>
                 </div>
               )}
               {project.figmaLink && (
                 <div className="pro_info flex space-x-40">
                   <p className='text-orange-400 font-bold text-md'>
                     <a href={project.figmaLink} target="_blank" rel="noopener noreferrer">Figma</a>
                   </p>
                 </div>
              )}
            </div>
          </div>
        ))}
      </div>
      </Zoom>
      <section className='lg:p-20'>
      <Slide bottom>
          <ReachMe />
        </Slide>
      </section>
     
    </section>
  );
}

export default Projects;
